import { createAction } from "@reduxjs/toolkit";
import { Answer, Product } from "utils/types";

export const setQuizQuestions = createAction<[]>("quiz/SET_QUIZ_QUESTIONS");
export const setProducts = createAction<[]>("products/SET_PRODUCTS");
export const setUserGamingStyle = createAction<string>("user/SET_USER_GAMING_STYLE");
export const setIsQuizAnswered = createAction<boolean>("user/IS_QUIZ_ANSWERED");
export const setQuizAnswers = createAction<Answer>("user/SET_QUIZ_ANSWERS");
export const setSelectedProduct = createAction<Product>(
  "user/SET_SELECTED_PRODUCT"
);
